import { Component, OnInit, Injectable } from '@angular/core';
import * as d3 from "d3";
import { Router, ActivatedRoute } from '@angular/router';
import { SessionService } from '../../services/session.service';
import { ValidationsService } from '../../services/validations.service';
import { CatalogosService } from '../../services/catalogos.service';
import { environment } from '../../../environments/environment';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { EmitterVisitorContext } from '@angular/compiler';

@Component({
  selector: 'app-home',
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss']
})
@Injectable({
  providedIn: 'root'
})
export class HomePage implements OnInit {
  faInfoCircle = faInfoCircle;

  loading: any = false;
  hasSession: any = false;
  llaveData: any = {};
  tramites: any = [];
  localRoute: any = {
    _value: null
  };
  confirmados: any = "";
  negativos: any = "";
  sospechosos: any = "";
  alcaldias: any = "";
  selectedViz: any = "";
  dataObject: any = "TEST";

  prueba = {
    x: "fecha",
    y: "serie1-1",
    style: {
      stroke: "#2977a2",
      fill: "#2ade60"
    },
    style_mouseover:{
      fill: "#98def5"
    },
    data: {}
  }


  constructor(
    public route: Router,
    private router: ActivatedRoute,
    private sessionService: SessionService,
    private validateService: ValidationsService,
    private catalogosService: CatalogosService
  ) {
    this.localRoute = this.router.queryParams;
  }

  async ngOnInit() {
    // Validate if session is active and exists
    this.loading = true;
    // await this.ngHandleSession();
    // wait for session callback
    // await this.ngCitizenProcesses();
    this.selectedViz = 'activos';
    this.confirmados = await this.catalogosService.getConfirmados();
    this.negativos = await this.catalogosService.getNegativos();
    this.sospechosos = await this.catalogosService.getSospechosos();
    this.alcaldias = await this.catalogosService.getSelect();

    this.loading = false;

    
  }

  private async getData(vizName) {

    let data: any = [];

    if(vizName == 'sintomas'){
      data = await d3.json("https://datos.cdmx.gob.mx/api/records/1.0/analyze/?disjunctive.resultado=true&timezone=America%2FMexico_City&dataset=casos-asociados-a-covid-19&x=fecha_sintomas.year&x=fecha_sintomas.month&x=fecha_sintomas.day&sort=x.fecha_sintomas.year,x.fecha_sintomas.month,x.fecha_sintomas.day&maxpoints=&y.serie1-1.expr=edad&y.serie1-1.func=COUNT&y.serie1-1.cumulative=false&lang=es");
    }
    else{
      console.log("test, otras bars");
    }

    

    data.forEach(d => 
      
        d["fecha"] = new Date(`${d.x.year}-${d.x.month}-${d.x.day}`) );

    this.dataObject = data;

    
    return data;

    
  }


  async ngCitizenProcesses() {
    // TODO get the proccess that logged in citizen has
    console.log("llave => ", this.llaveData);
    if (!this.llaveData) {
      return;
    }

    await this.validateService.getCitizenProcesses(this.llaveData.curp)
      .then(async (response) => {
        let nArray = [];

        response.map((item) => {
          let tramite = {
            dependencia: item.dependencia,
            id: item.id,
            id_dependencia: item.id_dependencia,
            id_formulario: item.id_formulario,
            id_tramite: item.id_tramite,
            nombre: item.nombre,
            status: this.setStatus(item.status),
            timestamp: item.timestamp
          };

          this.catalogosService.getDependencia(item.id_dependencia)
            .then((res) => {
              let response: any = {
                dependency: ""
              };
              response = res

                tramite.dependencia = response.dependency.name;

            })

          console.log("tramite => ", tramite)
          this.tramites.push(tramite);
        })
      })
      .catch((err) => {
        console.log("err", err);
      })
  }

  async ngHandleSession() {
    this.hasSession = await this.sessionService.getSession();
    if (this.localRoute._value.code && !this.hasSession) {
      await this.sessionService.login(this.localRoute._value)
        .then((response) => {
          // Final validation that payload isn't empty
          this.llaveData = response !== undefined ? response : null;
          this.hasSession = response !== undefined ? true : false;
        }).
        catch((err) => {
          // TODO handle error messeges
          this.hasSession = false;
        });
    } else {
      this.llaveData = JSON.parse(localStorage.getItem(environment.auth.key));
    }
  }

  setStatus(status) {
    let nStatus = '';

    if (status === 0) {
      nStatus = "No revisado";
    } else if (status === 1) {
      nStatus = "En revisión";
    } else if (status === 2) {
      nStatus = "Aprobado";
    } else if (status === 3) {
      nStatus = "Rechazado";
    }

    return nStatus;
  }

  toggleViz(viz_name){
    this.selectedViz = viz_name;
  }


  // Redirect to llave to start login
  ngStartSession () {
    window.location.href=`${environment.llave.llave_url}?client_id=${environment.llave.client_id}&redirect_url=${environment.llave.redirect_url}&state=bXH2EHTPhKD1a6UokpnGZETSsaI8k6nZX9eptH688Hs1Qk_AXJZGJjUFODP5Lr8f`;
  }
}
